import React from 'react';
import { useOrderSaleAccountIdInputQuery } from '../../../../../../../../services';
import { RhSingleAutocomplete } from '../../../../../../../dum';
import {
    IOrderSale,
    ORDER_REQUEST,
    TRANSFER_RECEIPTS,
} from '../../order-sale-form';
import { useFormContext, useWatch } from 'react-hook-form';
import { usePrefillFromClientAccount } from '../../use-prefill-from-client-account';
import {
    ORDER_SALE_FIELD_LABELS,
    shortLabel,
} from '../../../../../../../../helpers';

export function AccountIdInput() {
    const inputName: keyof IOrderSale = 'account';
    const { data } = useOrderSaleAccountIdInputQuery();
    const rx = useFormContext();
    const { prefillFromAccount } = usePrefillFromClientAccount();
    const orderRequest = useWatch({
        name: ORDER_REQUEST,
    }) as IOrderSale['order_request'];

    // A payment is already applied from this client, so the client is
    // locked (the backend rejects the change too).
    const transferReceipts = useWatch({
        name: TRANSFER_RECEIPTS,
    }) as IOrderSale['transfer_receipts'];
    const hasTransfers = !!transferReceipts?.length;

    const accounts = data?.getAccounts || [];

    return (
        <RhSingleAutocomplete
            itemText={'name'}
            itemValue={'id'}
            name={inputName}
            label={shortLabel(ORDER_SALE_FIELD_LABELS.account_id)}
            options={accounts}
            returnObject
            disabled={!!orderRequest || hasTransfers}
            helperText={
                hasTransfers
                    ? 'No se puede cambiar: la venta tiene transferencias'
                    : undefined
            }
            onChange={(account) => {
                // Pre-fill payment date + credit-note/supplement defaults from
                // the picked client account.
                prefillFromAccount(account as IOrderSale['account']);
                void rx.trigger(ORDER_REQUEST);
            }}
        />
    );
}
